import isEqual from "lodash/isEqual"

export type Diff = <T extends object>(a: T, b: T) => Partial<T> | null

export const diff: Diff = (a, b) => {
  const result: Partial<typeof a> = {}

  if (a === b) {
    return null
  }

  if (a && !b) {
    return a
  }

  if (b && !a) {
    return b
  }

  // eslint-disable-next-line no-restricted-syntax
  for (const key in a) {
    if (Object.prototype.hasOwnProperty.call(a, key)) {
      if (!isEqual(a[key], b[key])) result[key] = b[key]
    }
  }
  // object b may have keys that don't exist in a
  // eslint-disable-next-line no-restricted-syntax
  for (const key in b) {
    if (Object.prototype.hasOwnProperty.call(b, key) && !(key in a)) {
      result[key] = b[key]
    }
  }

  if (Object.keys(result).length === 0) {
    return null
  }

  return result
}
